__webpack_require__.p = "/crisis-lab/fr/";